import Component from '../../common/Component';
import AnnouncementItem from './AnnouncementItem';
import LoadingIndicator from '../../common/components/LoadingIndicator';
import Icon from '../../common/components/Icon';
import Link from '../../common/components/Link';
import app from '../../admin/app';
export default class AnnouncementList extends Component {
  view() {
    const {
      announcements,
      loading,
      error,
      onRetry
    } = this.attrs;
    if (loading) {
      return m("div", {
        className: "AnnouncementList-state"
      }, m(LoadingIndicator, null));
    }
    if (error) {
      return m("div", {
        className: "AnnouncementList-state AnnouncementList-state--error"
      }, m(Icon, {
        name: "fas fa-exclamation-circle"
      }), m("p", null, app.translator.trans('core.admin.announcements.load_error')), m("button", {
        className: "Button",
        onclick: onRetry
      }, app.translator.trans('core.admin.announcements.retry')));
    }
    if (!(announcements != null && announcements.length)) {
      return m("div", {
        className: "AnnouncementList-state AnnouncementList-state--empty"
      }, m(Icon, {
        name: "fas fa-bullhorn"
      }), m("p", null, app.translator.trans('core.admin.announcements.empty')));
    }
    return m("div", {
      className: "AnnouncementList"
    }, announcements.map(a => m(AnnouncementItem, {
      key: a.id,
      announcement: a
    })), m(Link, {
      className: "AnnouncementList-viewAll",
      href: "https://discuss.flarum.org/t/blog",
      external: true,
      target: "_blank"
    }, m(Icon, {
      name: "fas fa-external-link-alt"
    }), app.translator.trans('core.admin.announcements.view_all')));
  }
}
flarum.reg.add('core', 'admin/components/AnnouncementList', AnnouncementList);